import _slicedToArray from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import cx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import Box from '@material-ui/core/Box';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { MButton } from '../../../@material-extend/Buttons/MButton';
import { Links } from '../../../components/links';
import { UseOnClickOutside } from '../../../helpers/UseOnClickOutside';
import { CREATE, ClientNames, MINI_TOOLS, RESOURCES, TABS_NAME } from '../../../models';
import { useStyles } from '../../../models/styles/mainTabs';
export var MainTabs = function MainTabs(_ref) {
  var intl = _ref.intl,
      Link = _ref.Link,
      clientName = _ref.clientName,
      isLogin = _ref.isLogin,
      user = _ref.user;
  var urls = ['calendar', 'graphicmaker', 'fontpairer', 'colors', 'copywriter'];

  var _useState = useState([ClientNames.calendar, ClientNames.graphicmaker, ClientNames.fontpairer, ClientNames.color_matcher, ClientNames.copywriter].includes(clientName) ? 0 : -1),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  useEffect(function () {
    var _a;

    if ([ClientNames.calendar, ClientNames.graphicmaker, ClientNames.fontpairer, ClientNames.color_matcher, ClientNames.copywriter].includes(clientName)) {
      var queryPath = typeof window !== 'undefined' ? window.location.pathname : null;
      var paths = ((_a = queryPath === null || queryPath === void 0 ? void 0 : queryPath.slice(1)) === null || _a === void 0 ? void 0 : _a.split('/')) || [];
      setIndex(paths.length > 1 && urls.includes(paths[0]) ? -1 : 0);
    }
  }, []);
  var node = useRef();
  var classes = useStyles();

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var handleClick = function handleClick(key) {
    return setIndex(key === index ? -1 : key);
  };

  UseOnClickOutside(node, function () {
    return setIndex(-1);
  });
  return React.createElement(Box, {
    ref: node,
    sx: {
      gap: '30px',
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    }
  }, TABS_NAME.map(function (tab, key) {
    var _a;

    return React.createElement("div", {
      key: key,
      className: classes.bb0
    }, React.createElement(Box, {
      component: 'div',
      sx: {
        height: '44px',
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center'
      },
      className: cx(classes.bb0, classes.pointer)
    }, tab.name !== 'Pricing' ? React.createElement(MButton, {
      onClick: function onClick(e) {
        e.preventDefault();
        handleClick(key);
      },
      className: cx(index === key ? classes.selectedTabButton : '', classes.menuTabButton)
    }, tab.name === 'Create' ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'create',
      defaultMessage: 'Create'
    }) : tab.name === 'Tools' ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'tools',
      defaultMessage: 'Tools'
    }) : tab.name === 'Resources' ? intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'resource',
      defaultMessage: 'Resources'
    }) : '', tab.name !== 'Pricing' && React.createElement(ExpandMore, {
      className: cx(index === key ? classes.rotate180 : '', classes.chevron)
    })) : !isLogin || isLogin && ((_a = user === null || user === void 0 ? void 0 : user.subscription) === null || _a === void 0 ? void 0 : _a.sub_category) === 'free' ? React.createElement(Links, {
      Link: Link,
      to: '/pricing',
      style: {
        textDecoration: 'none'
      }
    }, React.createElement(MButton, {
      className: cx(classes.pricingButton)
    }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
      id: 'pricing',
      defaultMessage: 'Pricing'
    }))) : ''), tab.name !== 'Pricing' && React.createElement(Box, {
      component: 'div',
      sx: {
        overflow: 'hidden',
        width: 'max-content'
      },
      className: index === key ? classes.open : index > key ? classes.open : classes.close
    }, React.createElement(Box, {
      component: 'div',
      sx: {
        borderTop: index > -1 ? 'solid 1px #ddd' : '',
        display: index === key ? 'block' : 'none'
      },
      className: tab.name === 'Create' ? classes.createDropdown : classes.child
    }, React.createElement("div", {
      className: cx(tab.name === 'Create' ? classes.createContainer : classes.child_container, index === key ? classes.opacity1 : classes.opacity0)
    }, //Create menu
    tab.name === 'Create' ? CREATE.map(function (tool, index) {
      return React.createElement(Box, {
        key: index,
        component: 'div',
        onMouseEnter: function onMouseEnter() {
          return setHover(index);
        },
        onMouseLeave: function onMouseLeave() {
          return setHover(null);
        },
        className: cx(hover === index ? classes.backgrounds : '', classes.toolsButton)
      }, tool.shortName === 'Mockup' ? React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          marginRight: '20px',
          position: 'relative'
        },
        className: classes.mm_csoon
      }, React.createElement("strong", {
        className: classes.csoon
      }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
        id: 'coming_soon',
        defaultMessage: 'COMING SOON'
      })), React.createElement("div", {
        className: classes.blury
      }, React.createElement("img", {
        src: tool.png,
        className: classes.hw50
      }))) : React.createElement(Links, {
        Link: Link,
        outside: true,
        to: isLogin ? tool.link : tool.url,
        style: {
          textDecoration: 'none'
        }
      }, React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          flexDirection: 'row',
          paddingTop: '0px',
          alignItems: 'start'
        }
      }, React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          textAlign: 'center',
          alignItems: 'center',
          marginRight: '24px'
        }
      }, React.createElement("img", {
        src: tool.png,
        className: classes.hw50
      })), React.createElement("div", {
        className: classes.transform
      }, React.createElement("span", {
        className: cx(classes.toolTitle)
      }, tool.title), React.createElement("p", {
        className: cx(classes.toolDesc)
      }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
        id: tool.descriptionKey,
        defaultMessage: tool.description
      }))))));
    }) : tab.name === 'Tools' ? MINI_TOOLS.map(function (tool, index) {
      return React.createElement(Box, {
        key: index,
        component: 'div',
        onMouseEnter: function onMouseEnter() {
          return setHover(index);
        },
        onMouseLeave: function onMouseLeave() {
          return setHover(null);
        },
        className: cx(hover === index ? classes.backgrounds : '', classes.otherToolsButton)
      }, React.createElement(Links, {
        Link: Link,
        outside: true,
        style: {
          textDecoration: 'none'
        },
        to: isLogin ? tool.link : tool.url
      }, React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          flexDirection: 'row',
          paddingTop: '0px',
          alignItems: 'start'
        }
      }, React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          textAlign: 'center',
          alignItems: 'center',
          marginRight: '24px'
        }
      }, React.createElement("img", {
        src: tool.png,
        className: classes.hw50
      })), React.createElement("div", {
        className: classes.transform
      }, React.createElement("span", {
        className: cx(classes.toolTitle)
      }, tool.title), React.createElement("p", {
        className: classes.toolDesc
      }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
        id: tool.description,
        defaultMessage: tool.info
      }))))));
    }) : tab.name === 'Resources' ? RESOURCES.map(function (tool, index) {
      var isOpenNewTab = ['Tutorials', 'Blog'].includes(tool.name);
      return React.createElement(Box, {
        key: index,
        component: 'div',
        onMouseEnter: function onMouseEnter() {
          return setHover(index);
        },
        onMouseLeave: function onMouseLeave() {
          return setHover(null);
        },
        className: cx(hover === index ? classes.backgrounds : '', classes.otherToolsButton)
      }, React.createElement(Links, {
        Link: Link,
        to: tool.url,
        outside: true,
        style: {
          textDecoration: 'none'
        },
        target: isOpenNewTab ? '_blank' : null,
        rel: isOpenNewTab ? 'noreferrer noopener' : 'noopener'
      }, React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          flexDirection: 'row',
          paddingTop: '0px',
          alignItems: 'start'
        }
      }, React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          textAlign: 'center',
          alignItems: 'center',
          marginRight: '24px'
        }
      }, React.createElement("img", {
        src: tool.png,
        className: classes.hw50
      })), React.createElement("div", {
        className: classes.transform
      }, React.createElement(Box, {
        component: 'div',
        sx: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, React.createElement("span", {
        className: cx(classes.toolTitle)
      }, tool.name), React.createElement("p", {
        className: cx(classes.toolDesc)
      }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
        id: tool.descriptionKey,
        defaultMessage: tool.description
      })))))));
    }) : ''))));
  }));
};